export type LegacyServiceIconSize = 80 | 120 | 150;
export type ServiceIconSize =
  | 'xx-small'
  | 'x-small'
  | 'small'
  | 'medium'
  | 'large'
  | LegacyServiceIconSize;

type ServiceIconConfig = {
  /** The border radius applied to the icon. */
  borderRadius: string;
  /** The iconSize between the icon shell and the icon image.
   * Used for the Img component, and is therefore a number instead of a PDL design token CSS variable.
   */
  iconSize: number;
  /** The width of the icon shell. */
  width: string;
};

export const ServiceIconConfig: {
  [key in ServiceIconSize | LegacyServiceIconSize]: ServiceIconConfig;
} = {
  'xx-small': {
    width: 'var(--zds-size-16)',
    borderRadius: 'var(--zds-radius-default)',
    iconSize: 8,
  },
  'x-small': {
    width: 'var(--zds-size-20)',
    borderRadius: 'var(--zds-radius-default)',
    iconSize: 14,
  },
  small: {
    width: 'var(--zds-size-small)',
    borderRadius: 'var(--zds-radius-default)',
    iconSize: 14,
  },
  medium: {
    width: 'var(--zds-size-medium)',
    borderRadius: 'var(--zds-radius-default)',
    iconSize: 24,
  },
  large: {
    width: 'var(--zds-size-large)',
    borderRadius: 'var(--zds-radius-default)',
    iconSize: 32,
  },
  80: {
    borderRadius: '10px',
    iconSize: 60,
    width: '80px',
  },
  120: {
    borderRadius: '15px',
    iconSize: 90,
    width: '120px',
  },
  150: {
    borderRadius: '18px',
    iconSize: 110,
    width: '150px',
  },
};
